export default class NotificationDisplayMethodError extends Error {
  constructor(public readonly original: Error) {
    super('Notification native display method failed');
    if (new.target) {
      Object.setPrototypeOf(this, new.target.prototype);
    }
    this.name = NotificationDisplayMethodError.name;
  }
}
